<template>
  <div class="order">
    <div class="p-title">网络广告投放</div>
    <div class="p-main">
      <div class="put_tabs" v-show="!isShowConfirm">
        <span v-for="{ componentName, title, type } in tabItems" :class="['put_tab_pane', { act: componentName === curTab }]" :key="componentName" @click="tabSelect(componentName, type)">
          {{ title }}
        </span>
      </div>
      <PutOrderWifiContainer v-if="showContent" @showConfirm="(v) => { isShowConfirm = v }"></PutOrderWifiContainer>
    </div>
  </div>
</template>

<script>
import PutOrderWifiContainer from './PutOrderWifiContainer'

export default {
  name: 'PutOrderWifi',
  components: { PutOrderWifiContainer },
  data() {
    return {
      curTab: 'putOrder',
      tabItems: [
        {
          title: '条件搜索',
          componentName: 'putOrder'
        },
        {
          title: '导入小区',
          componentName: 'communityImport'
        },
        {
          title: '导入点位',
          componentName: 'deviceImport'
        },
        {
          title: '订单复投',
          componentName: 'orderReput',
          type: 'orderReput'
        }
      ],
      isShowConfirm: false,
      showContent: true
    }
  },
  provide() {
    return {
      pageVm: this
    }
  },
  beforeDestroy() {
    this.$store.commit('setWifiPutMode', false) // wifi 投放模式store设置为 false
    this.init()
  },
  created() {
    this.$store.commit('setWifiPutMode', true) // wifi 投放模式store设置为 true
    this.init()
  },
  methods: {
    init() {
      let { componentName, type } = this.tabItems[0]
      this.$store.commit('order/setCoditionSearchType', componentName || '') // 初始设置状态为条件筛选
      this.$store.commit('order/setData', { key: 'searchTabType', value: type || '' })
    },
    tabSelect(tabName, type) {
      if (tabName === this.curTab) return
      this.curTab = tabName
      this.$store.commit('order/setCoditionSearchType', tabName)
      this.$store.commit('order/setData', { key: 'searchTabType', value: type })
      this.showContent = false
      this.$nextTick(() => {
        this.showContent = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.put_tabs {
  height: 50px;
  padding: 0 10px;
  background-color: #f5f5f5;
  box-shadow: 0 -1px 0 0 #d4d4d4 inset;
}

.put_tab_pane {
  display: inline-block;
  padding: 9px 28px;
  margin-top: 8px;
  margin-left: 10px;
  color: #666666;
  font-size: 16px;
  line-height: 22px;
  background-color: #f5f5f5;
  border: 1px solid #d4d4d4;
  border-radius: 4px 4px 0 0;
  cursor: pointer;

  &:hover {
    color: #000;
  }

  &.act {
    color: #282729;
    background-color: #ffffff;
    border-bottom-color: #fff;
    font-weight: bolder;
  }
}
</style>
